/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { ToDoOfferItem, ToDoOfferItemToDoStatusEnum } from 'client-code/recordings';

import { Locale, LocaleKeys } from '../../../../core/locale';
import { getToDoListOfferItemIconClassname } from '../ToDoList/ToDoList.utils';

interface ConflictInfoProps {
    selectedTodoItem: ToDoOfferItem;
    preview: string;
}
const ConflictInfo = ({ selectedTodoItem, preview }: ConflictInfoProps) => {
    return (
        selectedTodoItem.toDoStatus === ToDoOfferItemToDoStatusEnum.Conflict && (
            <div className="conflict-wrapper">
                <div className="conflict">
                    <div className="status-icon">
                        <div className={getToDoListOfferItemIconClassname(selectedTodoItem)}></div>
                    </div>
                    <span className="conflict-text">
                        {Locale.getString(LocaleKeys.WILL_NOT_RECORD)}
                    </span>
                </div>
                <div className="conflict content-airing-info program-preview-top">
                    <span>{preview}</span>
                    <div className="status-icon">
                        <div className="todo-info"></div>
                    </div>
                </div>
            </div>
        )
    );
};

export default ConflictInfo;
